export const environment = {
  production: true,
  apiUrl: 'https://developer.iptel.com.ar:441/api/',
  oneSignalAppId: 'f88017d3-cc00-4c92-84b4-82e5060f6f9c'
};
